import { Operator } from "@jetjs/streams";
const create = (streamCount) => {
    let so;
    let completed = 0;
    return new Operator((s) => {
        so = s;
    }, (value) => so.next(value), (err) => so.error(err), () => {
        completed += 1;
        // the merge stream is completed, if all upstream Streams are completed
        if (completed === streamCount) {
            so.complete();
        }
    });
};
/**
 * merges the given Array of streams into one.
 *
 * @param observables to merge streams, they should contain the same type of data
 */
export const merge = (...observables) => {
    // create an operator, that just passes the value to the next subscriber (or operator)
    const mergeOperator = create(observables.length);
    // pipe every stream into the merge operator
    observables.forEach(o => o.pipe(mergeOperator));
    return mergeOperator;
};
//# sourceMappingURL=merge.js.map